import React from "react";
import { formatImages } from "../../../lib/images";
import { formatLinks } from "../../../lib/links";
import { getMultiChoice } from "../../../lib/multichoice";
import {
  KontentLinkedImage,
  KontentLinks,
  KontentMultiChoice,
  KontentNavigationItem,
  StringValue,
} from "../../../types";
import { LinkedImageProps } from "../../blocks/LinkedImage";
import { formatNavigation } from "../Header";
import { Footer } from "./Footer";

export interface KontentSiteFrameFooter {
  footer: {
    system: {
      id: string;
      type: string;
    };
    elements: {
      copyright: StringValue;
      images: KontentLinkedImage;
      navigation: {
        value: KontentNavigationItem[];
      };
      link_configuration__link: KontentLinks;
      style: KontentMultiChoice<"light" | "dark" | "transparent">;
      social_images: {
        value: {
          elements: LinkedImageProps;
        }[];
      };
    };
  };
}

const FooterContainer: React.FC<KontentSiteFrameFooter> = ({ footer }) => {
  if (!footer) {
    return null;
  }

  const id = footer.system.id;

  const { copyright, social_images, style, link_configuration__link } =
    footer.elements;

  const images = footer.elements?.images?.value.map(
    (image) => formatImages(image?.elements).largeImage
  );
  const navigation = footer.elements?.navigation?.value.map(formatNavigation);
  const secondaryNav = formatLinks(link_configuration__link.modular_content);
  const socialIcons = social_images.value
    ?.map((linkImage) => {
      return (
        linkImage?.elements.image?.modular_content && {
          link: formatLinks(
            linkImage?.elements.link_configuration__link?.modular_content
          )[0],
          image: formatImages(
            linkImage?.elements.image?.modular_content[0]?.elements
          ).largeImage,
        }
      );
    })
    .filter((link) => !!link);

  return (
    <Footer
      id={id}
      style={getMultiChoice(style) || "light"}
      copyright={copyright.value}
      images={images}
      secondaryNavigation={secondaryNav}
      socialIcons={socialIcons}
      navigation={navigation}
    />
  );
};

export default FooterContainer;
